

var jq$ = jQuery.noConflict(true);
/* wrap everything inside jQueryMain or inside an instance of jQueryMain to avain using the original jquery*/

/* accordion 
var accdz = document.getElementsByClassName("accordion-dz");
var idz;


for (idz = 0; idz < accdz.length; idz++) {
  accdz[idz].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
      panel.style.height = "100%";
    }
  });
}

/* end of accordion */


/* pdp lightbox */
jq$(document).ready(function($) {

});
/* end of pdp lightbox */

/* pdp subscribe / one time info show/hide */
// for bundles
jq$(window).on("load", function ($) {
  //$('.productMainBundle .bundleBuilder__sellingPlan.subscribe').trigger('click');
  //$('.productMainBundle .productMain__sellingPlan.single-subscribe').trigger('click');
});

jq$(document).ready(function($) {
  /*set defaults */
  //$('.productMainBundle .bundleBuilder__sellingPlan.subscribe').addClass('active');

  
  jq$(".productMainBundle .bundleBuilder__sellingPlan").click(function(){
    jq$('.productMainBundle .bundleBuilder__sellingPlan').removeClass('active');
    jq$(this).addClass('active');
  });
});
// for single purchase
jq$(document).ready(function($) {
  var oldURL = window.location.href;
  jq$(".productMainBundle .productMain__sellingPlan.single-subscribe .selection-wrapper").click(function(){
    /* select subscription */
    jq$('input.single-subscribtion-plan').prop("checked", true);
    jq$('input.single-onetime-plan').prop("checked", false);

    /* select the current selling plan from dropdown */
    var initial_plan = $('.productMain__sellingPlan.single-subscribe .productMain__sellingPlanSelector option:selected').val();
    
    /* add selling plan to url */
    if (history.pushState) {
        var newUrl = oldURL + "?selling_plan=" + initial_plan;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }

    /* add selling plan to add to cart button */
    jq$('.cta-add-cart-btn').attr('selling-plan', initial_plan);
  });
  /* on change of selling plan options, update selected plan from url info */
  jq$(".productMain__sellingPlan.single-subscribe .productMain__sellingPlanSelector select").change(function() {
    //var selected_plan = (new URL(location.href)).searchParams.get('selling_plan');
    var selected_plan = $(this).val();
    console.log(selected_plan);
    jq$('.productMain__addToCartButton .cta-add-cart-btn').attr('selling-plan', selected_plan);
    /* show mobile cta btn */
    jq$('.productMainBundle .mobile-fixed-buttons .bundleBuilder__actions.selling-plans-dz').removeClass('active');
    jq$('.productMainBundle .mobile-fixed-buttons .productMain__addToCartContainer').addClass('active');
  });
  
  /* remove selling plan on cart button if one time is selected */
  jq$(".productMainBundle .bundleBuilder__sellingPlan").click(function(){
    jq$('.productMainBundle .bundleBuilder__sellingPlan').removeClass('active');
    jq$(this).addClass('active');
  });
  jq$(".productMainBundle .productMain__sellingPlan.single-subscribe").click(function(){
    jq$('.productMainBundle .productMain__sellingPlan').removeClass('active');
    jq$(this).addClass('active');
  });
  jq$(".productMainBundle .productMain__sellingPlan.onetime").click(function(){
    jq$('.productMainBundle .productMain__sellingPlan').removeClass('active');
    jq$(this).addClass('active');
    
    
  });
  
});



jq$(document).ready(function() {
    setTimeout(function() {
         $('.productMainBundle .bundleBuilder_title-desc.subscribe').trigger('click');
    }, 2000);

  /* initialize sliders */
  gallerySlider();
  heroAccordionSlider();
  
  featUgcSlider();
  featProdSlider();
  differenceTabSlider();
  upsellSlider();
  scienceMobSlider();
});


function scienceMobSlider() {
  if (jq$(window).width() < 767) {
      jq$(".text-column-science-backed-pdpv2 .sc-content-slider-option ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true
      });
      console.log('slickme');
    } else {
      console.log('do nothing');
      jq$(".text-column-science-backed-pdpv2 .sc-content-slider-option.slick-initialized ").slick('unslick');
    }
}
function heroAccordionSlider() {
  if (jq$(window).width() > 851) {
      console.log('do nothing');
      jq$(".hero-promo-pdpv2 .accordion-wrap-pdpv2.slick-initialized ").slick("unslick");
    } else {
      console.log('slickme');
      jq$(".hero-promo-pdpv2 .accordion-wrap-pdpv2 ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              dots: true,
              arrows: false,
              slidesToShow: 1,
            },
          },
        ],
      });
    }
}
function featUgcSlider() {
  if (jq$(window).width() > 1200) {
      console.log('do nothing ugc');
      jq$(".feature-vid-ugc .vid-list.slick-initialized ").slick("unslick");
    } else {
      console.log('slickme ugc');
      jq$(".feature-vid-ugc .vid-list ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              dots: false,
              centerMode: true,
              centerPadding: "30px"
            },
          },
        ],
      });
    }
    
  }
function featProdSlider() {
  if (jq$(window).width() > 992) {
      console.log('do nothing');
      jq$(".feat-prods-pdpv2 .featuredBlocks__content.slick-initialized ").slick("unslick");
    } else {
      console.log('slickme');
      jq$(".feat-prods-pdpv2 .featuredBlocks__content ").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  
}
function differenceTabSlider() {
  jq$(".overlay-yerba-pdpv2 .text-wrapper-all").not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  });
}
function gallerySlider() {
  jq$(".mob-gallery-wrap-dz .pdpv2-images-grid.dz-gallery").not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: "60px",
  });
}
function upsellSlider() {
    if (jq$(window).width() > 992) {
      jq$(".pdp-main-productv2 .upsell-wrap.slick-initialized").slick("unslick");
      console.log('upsell unslick');
    } else {
      console.log('upsell slick');
      jq$(".pdp-main-productv2 .upsell-wrap").not('.slick-initialized').slick({
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 550,
            settings: {
              dots: true,
              arrows: true,
              slidesToShow: 1,
            },
          },
        ],
      });
    }
  }
/* =========== 
 on resize of window, initialize slider
  ==============*/

jq$(window).resize(function() {
  gallerySlider();
  scienceMobSlider();
  heroAccordionSlider();  
  featUgcSlider();
  featProdSlider();
  differenceTabSlider();
  upsellSlider();
});


jq$(document).ready(function ($) {
  // add all to same gallery
  $(".dz-gallery a").attr("data-fancybox", "mygallery");
  
  // assign captions and title from alt-attributes of images:
  $(".dz-gallery a").each(function () {
    $(this).attr("data-caption", $(this).find("img").attr("alt"));
    $(this).attr("title", $(this).find("img").attr("alt"));
  });
  // start fancybox:
  $(".dz-gallery a").fancybox();

   $("#nutrition-popup").fancybox({
     openEffect	: 'elastic',
     closeEffect	: 'elastic',
     helpers : {
     title : {
     type : 'inside'
          }
       }
  });
  /* initial loads */
  
  $(".productMainBundle .bundle-click-btn").click(function(){
    $('.productMainBundle .bundleBuilder_title-desc.subscribe-desc').click();
  });
  
  /* sticky of add to cart on mobile */
  var mainBtn = $('.bundle-tablist');
  var mobileBtn = $('.productMainBundle .productMain__addToCartContainer, .productMainBundle .actions-dz');


    $(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();

    $('.bundle-tablist').each(function() {
        var topDistance = $(this).offset().top;

        if ( (topDistance+100) < scrollTop ) {
          mobileBtn.addClass('sticky');
          $('body').addClass('sticky');
        }else{
          mobileBtn.removeClass('sticky');
          $('body').removeClass('sticky');
        }
    });
  });

  /* on scroll counter feature */
  var a = 0;
  $(window).scroll(function() {

  var oTop = $('#num-counter-dzy').offset().top - window.innerHeight;
  if (a == 0 && $(window).scrollTop() > oTop) {
    $('.counter-value').each(function() {
      var $this = $(this),
        countTo = $this.attr('data-count');
      $({
        countNum: $this.text()
      }).animate({
          countNum: countTo
        },

        {

          duration: 2000,
          easing: 'swing',
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }

        });
    });
    a = 1;
  }

  });

  /* accordion slide */
  $('.acc-title.accordion-dz').click(function(){
    $(this).toggleClass('active');
    $(this).parent().find('.panel-dz.acc-cnt').slideToggle(280);
  });
});


/* ============================================================
   OFFERS PAGE — Optimized + Rebuy Disabled (No Reload Version)
============================================================ */
jq$(function ($) {
  console.log("🚀 Offers Page — Optimized + Rebuy Disabled (No Reload)");

  /* ------------------------------------------------------------
     Utility: Update step button state
  ------------------------------------------------------------ */
  function updateStepState() {
    const list = $(".prod-list");
    const minmax = Number(list.data("minmax"));
    const type = list.data("minmax-type");
    const count = Number(list.data("count"));
    const isReady =
      (type === "maxbase" && count === minmax) || (type !== "maxbase" && count >= minmax);
    $("#offer-step2").toggleClass("active", isReady);
  }

  /* ------------------------------------------------------------
     Utility: Update display price based on discount
  ------------------------------------------------------------ */
  function updatePlans() {
    const total = parseFloat($(".prod-list").data("total")) || 0;
    $(".product-select-wrap .box-wrap").each(function () {
      const discount = parseFloat($(this).data("rate")) || 0;
      const discounted = Math.ceil((total - total * (discount / 100)) * 100) / 100;
      $(this).find(".display-price").text(`$${discounted.toFixed(2)}`);
    });
  }

  /* ------------------------------------------------------------
     Quantity Controls (+ / −)
  ------------------------------------------------------------ */
  $(".plus-btn").off("click").on("click", function () {
    const list = $(".prod-list");
    let currentQty = Number(list.data("count")) || 0;
    const minmax = Number(list.data("minmax"));
    const type = list.data("minmax-type");

    const $li = $(this).closest(".prodselect");
    const price = parseFloat($li.data("price")) || 0;
    const qty = (Number($li.data("qty")) || 0) + 1;

    $li.data("qty", qty).attr("data-qty", qty).addClass("active");
    $li.find(".num-qty").text(qty);

    list.data("count", currentQty + 1).attr("data-count", currentQty + 1);
    const totalPrice = parseFloat(list.data("total")) + price;
    list.data("total", totalPrice).attr("data-total", totalPrice.toFixed(2));
    $(".dynamic-compare").text(`$${totalPrice.toFixed(2)}`);

    updateStepState();
    addLinks();
  });

  $(".minus-btn").off("click").on("click", function () {
    const list = $(".prod-list");
    let currentQty = Number(list.data("count")) || 0;

    const $li = $(this).closest(".prodselect");
    const price = parseFloat($li.data("price")) || 0;
    let qty = Number($li.data("qty")) || 0;

    if (qty > 0) {
      qty--;
      $li.data("qty", qty).attr("data-qty", qty);
      $li.find(".num-qty").text(qty);
      if (qty === 0) $li.removeClass("active");

      list.data("count", currentQty - 1).attr("data-count", currentQty - 1);

      const totalPrice = parseFloat(list.data("total")) - price;
      list.data("total", totalPrice).attr("data-total", totalPrice.toFixed(2));
      $(".dynamic-compare").text(`$${totalPrice.toFixed(2)}`);

      updateStepState();
      addLinks();
    }
  });

  /* ------------------------------------------------------------
     Step Navigation
  ------------------------------------------------------------ */
  $("#offer-step2").off("click").on("click", function (e) {
    e.preventDefault();
    if (!$(this).hasClass("active")) return;

    $(".offers-bundle .step1").removeClass("active");
    $(".offers-bundle .step2").addClass("active");

    updatePlans();
    clearCart();

    // Ensure checkout links populate after cart is cleared
    setTimeout(() => {
      addLinks();
      console.log("🔄 Initial checkout totals loaded on Step 2");
    }, 300);
  });

  $(".offer-backlink").off("click").on("click", function (e) {
    e.preventDefault();
    $(".offers-bundle .step1").addClass("active");
    $(".offers-bundle .step2").removeClass("active");
  });

  $(".offers-bundle .box-wrap").off("click").on("click", function () {
    $(".offers-bundle .box-wrap").removeClass("active");
    $(this).addClass("active");
    addLinks();
  });

  /* ------------------------------------------------------------
     Build Checkout Link
  ------------------------------------------------------------ */
  function addLinks() {
    const list = $(".prod-list");
    const type = list.data("minmax-type");
    const count = Number(list.data("count"));
    const minmax = Number(list.data("minmax"));
    const isSubscription = $("#subscribe-option").hasClass("active");

    list.toggleClass("max-active", type === "maxbase" && count >= minmax);

    let items = [];
    let totalPrice = 0;
    let totalSub = 0;

    $(".prodselect.active").each(function () {
      const $p = $(this);
      const id = $p.data("id");
      const qty = Number($p.data("qty")) || 0;
      const plan = $p.data("plan") || "";
      const price = parseFloat($p.data("price")) || 0;
      const subPrice = parseFloat($p.data("sub")) || 0;
      const bundles = ($p.data("bundled-variant-ids") || "").split(",").filter(Boolean);

      totalPrice += price * qty;
      totalSub += subPrice * qty;

      let item = `items[][id]=${id}&items[][quantity]=${qty}`;
      if (isSubscription && plan) item += `&items[][selling_plan]=${plan}`;
      items.push(item);

      bundles.forEach(bid => items.push(`items[][id]=${bid}&items[][quantity]=1`));
    });

    $("#subscribe-option .dynamic-compare").text(`$${totalSub.toFixed(2)}`);
    $("#onetime-option .dynamic-compare").text(`$${totalPrice.toFixed(2)}`);

    const currentTotal = isSubscription ? totalSub : totalPrice;
    const insureList = Array.from(document.querySelectorAll("#always-add-list li"));
    let chosenInsure = null;
    let insurePrice = 0;

    for (const li of insureList) {
      const min = parseFloat(li.dataset.min);
      const max = parseFloat(li.dataset.max);
      if (currentTotal >= min && currentTotal <= max) {
        chosenInsure = li.dataset.id;
        insurePrice = parseFloat(li.dataset.price) || 0;
        break;
      }
    }

    if (chosenInsure) {
      const insureString = `items[][id]=${chosenInsure}&items[][quantity]=1`;
      if (!items.some(i => i.includes(`items[][id]=${chosenInsure}`))) items.push(insureString);
    }

    $(".dynamic-shipinsure-price").text(`$${insurePrice.toFixed(2)}`);

    const discount = isSubscription
      ? $("#subscribe-option").data("discount") || ""
      : $("#onetime-option").data("discount") || "";
    const discountParam = discount ? `?discount=${discount}` : "";

    const checkoutUrl =
    "https://drinkmateina.com/cart/add?" + items.join("&") + "&return_to=/checkout" + discountParam;

    // ✅ Convert insure ID to string so filtering works
    const noShipItems = items.filter(i => !i.includes(String(chosenInsure)));

    const noShipUrl =
      "https://drinkmateina.com/cart/add?" + noShipItems.join("&") + "&return_to=/checkout" + discountParam;

    $("#offer-checkout").attr("href", checkoutUrl);
    $("#offer-checkout-noship").attr("href", noShipUrl);


    const activeDisplayEl = isSubscription
      ? $("#subscribe-option .display-price")
      : $("#onetime-option .display-price");

    const baseValue = parseFloat(activeDisplayEl.text().replace("$", "")) || 0;
    const totalWithShipInsure = baseValue + insurePrice;

    $("#offer-checkout .inside-text").text(`+| $${totalWithShipInsure.toFixed(2)}`);
    $("#offer-checkout-noship .pricing").text(`$${baseValue.toFixed(2)}`);

    console.log(
      `🧾 Checkout (${isSubscription ? "Subscription" : "One-time"}): $${totalWithShipInsure.toFixed(2)}`
    );
  }

  /* ------------------------------------------------------------
   Disable Rebuy widgets & scripts
  ------------------------------------------------------------ */
  (function () {
    const isOffersPage = window.location.pathname.includes("offers-builder");
    if (!isOffersPage) return;

    function disableRebuy() {
      document
        .querySelectorAll(".rebuy-cart__checkout-button, .rebuy-cart__actions, [id*='rebuy']")
        .forEach(el => (el.style.display = "none"));

      window.Rebuy = window.Rebuy || {};
      window.Rebuy.cart = { add: () => {}, update: () => {} };
      console.log("🧩 Rebuy disabled on Offers page");
    }

    disableRebuy();
    new MutationObserver(disableRebuy).observe(document.body, { childList: true, subtree: true });
  })();

  /* ------------------------------------------------------------
     Clear cart helper
  ------------------------------------------------------------ */
  function clearCart() {
    fetch("/cart/clear.js", { method: "POST" })
      .then(() => console.log("🧹 Cart cleared"))
      .catch(err => console.warn("⚠️ Cart clear failed:", err));
  }
});

/* ------------------------------------------------------------
   ShipInsure Modal Control
------------------------------------------------------------ */
jq$(function ($) {
  const modal = $("div[tabindex='-1']").has("._si-info-modal-content");
  const trigger = $("#_si-info-modal");

  trigger.on("click", function (e) {
    e.preventDefault();
    modal.fadeIn(200);
  });

  modal.on("click", function (e) {
    if ($(e.target).is(modal) || $(e.target).text().trim() === "×") {
      modal.fadeOut(200);
    }
  });
});

/* ------------------------------------------------------------
   Prevent Reloads / Navigations (Final Patch)
------------------------------------------------------------ */
jq$(function ($) {
  const isOffersPage = window.location.pathname.includes("offers-builder");
  if (!isOffersPage) return;

  // ✅ Prevent all non-checkout form reloads
  $(document).on("submit", "form", function (e) {
    e.preventDefault();
    console.log("🛑 Prevented form submission reload");
  });

  // ✅ Prevent # or empty links
  $(document).on("click", "a[href='#'], a[href='']", function (e) {
    e.preventDefault();
  });

  // ✅ Allow only checkout / noship / rebuy
  $(document).on("click", "a", function (e) {
    const href = $(this).attr("href");
    if (!href) return e.preventDefault();

    const isAllowed =
      href.includes("/checkout") ||
      href.includes("/cart/add") ||
      $(this).is("#offer-checkout-noship") ||
      $(this).is("#offer-checkout");

    if (!isAllowed) {
      e.preventDefault();
      console.log("🛑 Blocked unwanted reload:", href);
    }
  });

  // ✅ Remove beforeunload and disable bfcache reloads
  window.onbeforeunload = null;
  window.addEventListener("pageshow", function (e) {
    if (e.persisted) {
      console.log("♻️ Page restored from cache — preventing reload");
      e.stopImmediatePropagation();
    }
  });

  console.log("✅ Safe reload protection active — checkout unaffected");
});
